import { render, staticRenderFns } from "./le_tp_attribute.vue?vue&type=template&id=c9c994a0&scoped=true&"
import script from "./le_tp_attribute.vue?vue&type=script&lang=js&"
export * from "./le_tp_attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c994a0",
  null
  
)

export default component.exports